import { apiAuthClient } from 'shared/api/lib/apiAuthClient';

import type { GetTemplateRequestType, GetTemplateResponseType } from '../types';

export const getTemplateVersion = async ({
  pathParams: { templateId, version },
}: GetTemplateRequestType) => {
  const url = `/api/v2/templates/${templateId}/versions/${version}`;

  const { data } = await apiAuthClient.get<GetTemplateResponseType>(url);

  return data.data;
};
